/*
 * Замечание, которое открыть после перехода по уведомлению. Вкладка «Модель»
 * забирает его при показе (take) или, если уже открыта, сразу по сигналу (watch).
 * Номер привязан к работе: открытая вкладка другой работы его не трогает.
 * Забытый номер живёт недолго — потом считается устаревшим и не открывается.
 */
const TTL = 30_000;
let pending: { id: string; work: string; at: number } | null = null;
const watchers = new Set<() => void>();

export const pendingRemark = {
  set(id: string, work: string) {
    pending = { id, work, at: Date.now() };
    watchers.forEach((f) => f());
  },
  /** Номер замечания этой работы; без работы — любой (чтобы сбросить). Забранный номер не остаётся. */
  take(work?: string): string | null {
    const p = pending;
    if (!p) return null;
    if (Date.now() - p.at > TTL) {
      pending = null;
      return null;
    }
    if (work !== undefined && p.work !== work) return null;
    pending = null;
    return p.id;
  },
  /** Вкладка уже открыта: позвать, когда номер появится. Возвращает отписку. */
  watch(fn: () => void): () => void {
    watchers.add(fn);
    return () => void watchers.delete(fn);
  },
};
